import { LabraVenturesTheme } from '@labrav/react-components'
import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{ isViewOnly: boolean }>()(
  (theme: LabraVenturesTheme, { isViewOnly }) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      minHeight: 'calc(100vh - 80px)',
      boxSizing: 'border-box',
      gap: theme.spacing(3),
      padding: theme.spacing(4, 2, 4, 5),
    },
    topContainer: {
      display: 'flex',
      width: '100%',
      boxSizing: 'border-box',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginRight: theme.spacing(2),
    },
    templateHeading: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(0.5),
    },
    templateType: {
      color: theme.palette.labraText.description,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.spacing(1.75),
      lineHeight: theme.spacing(2.5),
    },
    templateNameContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
    name: {
      fontSize: '22px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '28px',
      color: theme.palette.labraText.primary,
      fontFamily: theme.typography.fontFamily,
      letterSpacing: '0px',
    },
    icon: {
      width: theme.spacing(2),
      height: theme.spacing(2),
      fontSize: '16px',
      color: theme.palette.select.light,
      opacity: isViewOnly ? 0.38 : 1,
    },
    hubspotIcon: {
      height: theme.spacing(3),
      width: theme.spacing(10.25),
    },
    middleContainer: {
      display: 'flex',
      width: '100%',
      boxSizing: 'border-box',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    fieldSearch: {
      display: 'flex',
      alignItems: 'center',
      width: theme.spacing(50),
      maxWidth: '100%',
      '& > div:last-child': {
        flex: 1,
      },
    },
    fieldFilter: {
      width: theme.spacing(10),
      flexShrink: 0,
    },
    fieldSearchInput: {
      position: 'relative',
      flex: 1,
      minWidth: 0,
      '& input': {
        paddingRight: theme.spacing(5),
      },
    },
    fieldSearchIcon: {
      position: 'absolute',
      right: theme.spacing(1.5),
      top: '50%',
      transform: 'translateY(-50%)',
      color: theme.palette.labraText.description,
      pointerEvents: 'none',
    },
    columnActionContainer: {
      height: theme.spacing(3),
      width: theme.spacing(3),
      alignContent: 'center',
    },
    bottomContainer: {
      display: 'flex',
      width: '100%',
      minWidth: 0,
      boxSizing: 'border-box',
    },
    footerWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: theme.spacing(3),
    },
    footerRoot: {
      height: theme.spacing(8),
      padding: theme.spacing(1.5, 5),
    },
    loadingSpinner: {
      color: `${theme.palette.button.secondary} !important`,
      width: '20px !important',
      height: '20px !important',
      marginLeft: 'auto',
      marginRight: 'auto',
      opacity: 1,
      marginTop: theme.spacing(4),
    },
  })
)
